"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultShareButton = exports.useShareButtonProps = void 0;
var tslib_1 = require("tslib");
// (C) 2021-2022 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var react_intl_1 = require("react-intl");
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
var model_1 = require("../../../../../model");
var HiddenShareButton_1 = require("./HiddenShareButton");
var selectors_1 = require("../selectors");
/**
 * @internal
 */
function useShareButtonProps() {
    var dispatch = model_1.useDashboardDispatch();
    var onShareButtonClick = react_1.useCallback(function () { return dispatch(model_1.uiActions.openShareDialog()); }, [dispatch]);
    var isVisible = model_1.useDashboardSelector(selectors_1.selectIsShareButtonVisible);
    return {
        isVisible: isVisible,
        onShareButtonClick: onShareButtonClick,
    };
}
exports.useShareButtonProps = useShareButtonProps;
/**
 * @alpha
 */
exports.DefaultShareButton = function (_a) {
    var isVisible = _a.isVisible, onShareButtonClick = _a.onShareButtonClick;
    var intl = react_intl_1.useIntl();
    if (!isVisible) {
        return react_1.default.createElement(HiddenShareButton_1.HiddenShareButton, null);
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(sdk_ui_kit_1.Button, { onClick: function () { return onShareButtonClick(); }, value: intl.formatMessage({ id: "share.button.text" }), className: "gd-button-secondary dash-header-share-button s-header-share-button gd-button gd-icon-users" })));
};
//# sourceMappingURL=DefaultShareButton.js.map